import { useState } from "react";
import { useAppAbility } from "@/casl";
import { IconButton } from "@/components/atoms";
import { NotificationsSidePanel } from "../Notifications";
import { SidebarLogo } from "../Sidebar/SidebarLogo";
import { HeaderModals } from "./HeaderModals";
import { HeaderNav } from "./HeaderNav";
import { HeaderProfileMenu } from "./HeaderProfileMenu";
import { HeaderSearch } from "./HeaderSearch";
import { HeaderSidePanel } from "./HeaderSidePanel";
import { HeaderSteps } from "./types";

export const Header = () => {
  const ability = useAppAbility();
  const showHeaderSearch = ability.can("manage", "providerClient");
  const [step, setStep] = useState<HeaderSteps>(undefined);
  const viewTransportProviderCode = () => setStep("viewTransportProviderCode");
  const viewNotifications = () => setStep("viewNotifications");

  return (
    <div className="z-40">
      <nav className="border-b border-neutral-mid-gray bg-white lg:border-0 lg:bg-transparent">
        {/* Desktop View */}
        <div className="hidden h-12 items-center bg-white px-5 py-2 lg:flex">
          <div className="flex flex-1">{showHeaderSearch && <HeaderSearch />}</div>
          <HeaderProfileMenu />
          <HeaderNav viewTransportProviderCode={viewTransportProviderCode} viewNotifications={viewNotifications} />
        </div>
        {/* Tablet/Mobile View */}
        <div className="flex h-20 items-center justify-between gap-4 px-5 lg:hidden">
          <SidebarLogo ignoreSidebarOpen className="-ml-4 flex flex-1" />
          <div className="-mr-2 flex items-center">
            <IconButton
              iconName="SearchNormal1"
              variant="tertiary"
              iconSize="lg"
              onClick={() => setStep("viewHeaderSearchModal")}
              className="ring-0"
            />
          </div>
          <div className="-mr-2 flex items-center">
            <IconButton iconName="HambergerMenu" variant="tertiary" iconSize="lg" onClick={() => setStep("viewHeaderSidePanel")} />
          </div>
        </div>
      </nav>
      <HeaderSidePanel
        open={step === "viewHeaderSidePanel"}
        onClose={() => setStep(undefined)}
        viewTransportProviderCode={viewTransportProviderCode}
        viewNotifications={viewNotifications}
      />
      <NotificationsSidePanel open={step === "viewNotifications"} onClose={() => setStep(undefined)} />
      <HeaderModals step={step} setStep={setStep} />
    </div>
  );
};
